export default __webpack_public_path__ + "static/media/880.75f498ce.png";